module.exports = __webpack_public_path__ + "static/title2-4afc7bc2ccd02a5c0203013533fa3fb1.png";